<template>
  <el-scrollbar ref="scrollbar" class="page_main_height">
    <el-row class="about">
      <div class="big_screen" :style="'background-image: url(' + filePath + '/nemojoyWebSiteFile/imgs/about/aboutBac.png); background-size: 100%; background-repeat: no-repeat; background-color: rgba(0, 0, 0, .9); background-position: 0 30.2vw'">
        <!--页头-->
        <index_head />

        <!--图片-->
        <div class="about_img" :style="'background-image: url(' + filePath + high_data.i +'); background-size: 100% auto'">
          <div class="about_img_content_title" draggable="false">{{ high_data.n }}</div>
          <el-row draggable="false" class="about_img_content" v-html="high_data.h " />
        </div>
        <!--发展历程-->
        <div class="about_development">
          <img class="about_development_title" :src="filePath + '/nemojoyWebSiteFile/imgs/about/aboutTitle.png'" alt="">
          <div class="about_development_line" />
          <template v-for="(old, i) in olds">
            <div :key="i" class="old_show">
              <div class="old_show_left old_show_item">
                <img v-if="i % 2 < 1" :src="filePath + old.i" alt="" draggable="false">
                <div v-else class="old_show_content" :style="'background-image: url(' + filePath + '/nemojoyWebSiteFile/imgs/about/aboutItemBac.png); background-repeat: no-repeat; background-size: 100% 100%;'">
                  <div class="old_show_content_title"> {{ old.t }} </div>
                  <div class="old_show_content_line">
                    <div class="old_show_content_line_line" />
                    <div class="old_show_content_line_point" />
                  </div>
                  <div class="old_show_content_text">
                    <el-row v-html="old.c" />
                  </div>
                </div>
              </div>
              <div class="old_show_line" />
              <div class="old_show_right old_show_item">
                <img v-if="i % 2 > 0" :src="filePath + old.i" alt="" draggable="false">
                <div v-else class="old_show_content" :style="'background-image: url(' + filePath + '/nemojoyWebSiteFile/imgs/about/aboutItemBac.png); background-repeat: no-repeat; background-size: 100% 100%;'">
                  <div class="old_show_content_title"> {{ old.t }} </div>
                  <div class="old_show_content_line">
                    <div class="old_show_content_line_point" />
                    <div class="old_show_content_line_line" />
                  </div>
                  <div class="old_show_content_text">
                    <el-row v-html="old.c" />
                  </div>
                </div>
              </div>
            </div>
          </template>
          <div class="about_development_bottom_line" />
        </div>

        <!--页脚-->
        <index_bottom />
      </div>

      <!--小屏显示-->
      <div class="small_screen">
        手机页面正在建设中，请使用pc浏览器打开
      </div>
    </el-row>
  </el-scrollbar>
</template>

<script>
import { get_about_data, get_development_data } from '@/api/about'
import vv from '@/components/varVariable'

export default {
  name: 'About',
  data() {
    return {
      high_data: {},
      olds: [],
      h: ''
    }
  },
  computed: {
    filePath() {
      return vv.fileHttp
    }
  },
  created() {
    get_about_data()
      .then(d => {
        this.high_data = d
      })

    get_development_data()
      .then(d => {
        this.olds = d
      })
  },
  methods: {
    e2_class(i, l) {
      return i < l - 1 ? 'e2' : 'e2 long'
    }
  }
}
</script>

<style lang="scss" scoped>
html, body, .about, .high, .high_show{
  width: 100%;
  font-size: 14px;
}

.about{
  .big_screen{
    height: auto;

    .about_img{
      width: 100vw;
      height: 30.23vw;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      div{
        font-size: 25px;
        color: rgba(255, 255, 255, .7);
        line-height: 40px;
      }

      .about_img_content_title{
        font-size: 40px;
        color: white;
        margin-bottom: 20px;
      }
    }

    .about_development{
      width: 100%;
      margin-top: 26px;
      display: flex;
      align-items: center;
      flex-direction: column;

      .about_development_title{
        width: 203px;
        height: 54px;
        margin-bottom: -1px;
        position: relative;
        z-index: 2;
      }

      .about_development_line{
        width: 8px;
        height: 40px;
        background-color: #6E6E6E;
      }

      .old_show{
        width: 910px;
        height: auto;
        min-height: 170px;
        display: flex;
        justify-content: center;
        align-items: center;

        .old_show_line{
          width: 8px;
          height: 300px;
          background-color: #6E6E6E;
          position: absolute;
        }

        .old_show_item{
          width: 450px;
          min-height: 133px;
          display: flex;
          align-items: center;

          .old_show_content{
            width: 100%;
            min-height: 100%;
            padding-top: 10px;

            .old_show_content_title{
              font-size: 26px;
              color: #666666;
              line-height: 48px;
              font-style: italic;
            }

            .old_show_content_text{
              font-size: 14px;
              color: #CDCBCC;
              padding: 12px ;
            }

            .old_show_content_line{
              display: flex;
              align-items: center;
              position: relative;
              z-index: 2;

              .old_show_content_line_point{
                width: 14px;
                height: 14px;
                border-radius: 50%;
                background-color: #800500;
              }

              .old_show_content_line_line{
                width: 220px;
                height: 5px;
                background-color: #800500;
              }
            }
          }

          img{
            width: 390px;
            height: 133px;
          }
        }

        .old_show_left{
          padding-right: 60px;
          justify-content: flex-end;

          .old_show_content{
            display: flex;
            align-items: flex-end;
            flex-direction: column;
            padding-right: 35px;

            .old_show_content_line{
              margin-right: -102px;

              .old_show_content_line_line{
                margin-right: -2px;
              }
            }

            .old_show_content_text{
              padding-left: 40px;
            }
          }
        }

        .old_show_right{
          padding-left: 60px;
          justify-content: flex-start;

          .old_show_content{
            padding-left: 35px;

            .old_show_content_text{
              padding-right: 20px;
            }

            .old_show_content_line{
              margin-left: -101px;

              .old_show_content_line_line{
                margin-left: -2px;
              }
            }
          }
        }
      }

      .about_development_bottom_line{
        width: 8px;
        height: 80px;
        background-color: #6E6E6E;
      }
    }
  }
}
</style>
